import SectionWrapper from '@/components/feature/SectionWrapper';
import SEO, { siteUrl } from '@/components/feature/SEO';

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';

const HERO_BG = 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20boxing%20gym%20interior%20with%20dramatic%20red%20spotlights%20cutting%20through%20smoke%20and%20haze%2C%20heavy%20punching%20bags%20silhouetted%20against%20black%20background%2C%20premium%20sports%20atmosphere%2C%20moody%20high%20contrast%20lighting%2C%20professional%20combat%20sports%20training%20facility%2C%20smoke%20texture%20and%20volumetric%20lighting%2C%20deep%20shadows%2C%20editorial%20sports%20photography%20style&width=1920&height=800&seq=trainers-hero-bg&orientation=landscape';

const TRAINER_1_IMG = 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/66e54a4685373c23b5cd6b9e56713d0f.png';

const TRAINER_2_IMG = 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/c1a6c71be5b027b81218d0f707cc4d42.png';

const TRAINER_3_IMG = 'https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/884ba7d8ec0ddb8b0a4346b876466f5e.png';

const trainers = [
  {
    name: 'MOIN KHAN',
    designation: 'Head Coach / International Boxing Champion',
    image: TRAINER_1_IMG,
    specialties: [
      'Professional Boxing',
      'Combat Training',
      'Champion Conditioning',
      'Private Coaching',
      'Youth Development',
    ],
    intro:
      'Train under Moin Khan, an accomplished international boxing champion with experience competing at elite levels. His coaching focuses on technical excellence, discipline, confidence building, and developing a true champion mindset for students of all levels.',
  },
  {
    name: 'QAMAR MAJEEB',
    designation: 'Senior Combat & Fitness Trainer',
    image: TRAINER_2_IMG,
    specialties: [
      'Boxing',
      'Kickboxing',
      'Fitness Training',
      'Weight Loss Transformation',
    ],
    intro:
      'Qamar Majeeb brings strong hands-on coaching experience in boxing, kickboxing, fitness conditioning, and weight loss transformation. His training style focuses on discipline, technique improvement, endurance building, and helping students achieve measurable physical results.',
  },
  {
    name: 'KASHIF BOXER',
    designation: 'MMA & Martial Arts Trainer',
    image: TRAINER_3_IMG,
    specialties: ['MMA', 'Kickboxing', 'Wushu Kung Fu'],
    intro:
      'Kashif Boxer specializes in mixed martial arts and striking disciplines, bringing dynamic combat training experience in MMA, kickboxing, and Wushu Kung Fu. His sessions are focused on agility, self-defence, discipline, and real combat skill development.',
  },
];

const reasons = [
  {
    icon: 'ri-boxing-line',
    title: 'Expert Combat Coaching',
    description: 'Train with experienced professionals',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Personal Attention',
    description: 'Structured coaching for all skill levels',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Fitness & Transformation',
    description: 'Strength, stamina, and weight management',
  },
  {
    icon: 'ri-team-line',
    title: 'Kids & Adult Training',
    description: 'Programs for children and adults',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Self Defence Skills',
    description: 'Practical real-world confidence building',
  },
];

export default function TrainersPage() {
  return (
    <main>
      <SEO
        title="Meet Our Elite Trainers — Moin Khan Boxing Academy | Islamabad"
        description="Train under Moin Khan, Qamar Majeeb, and Kashif Boxer — experienced combat sports professionals specializing in boxing, MMA, kickboxing, and fitness training in Islamabad. Book a free trial today."
        keywords="boxing trainers Islamabad, Moin Khan coach, MMA trainer Pakistan, kickboxing coach, combat sports coaches, boxing coach Pakistan"
        canonicalUrl={siteUrl ? `${siteUrl}/trainers` : undefined}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            '@id': `${siteUrl}/trainers#page`,
            url: `${siteUrl}/trainers`,
            name: 'Elite Trainers — Moin Khan Boxing Academy',
            description: 'Meet the experienced combat sports professionals at Moin Khan Boxing Academy in Islamabad.',
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  item: {
                    '@type': 'Person',
                    name: 'Moin Khan',
                    jobTitle: 'Head Coach / International Boxing Champion',
                    description: 'International boxing champion with elite-level competition experience. Coaching focuses on technical excellence, discipline, confidence building, and champion mindset.',
                    affiliation: { '@type': 'Organization', name: 'Moin Khan Boxing Academy', '@id': `${siteUrl}/#organization` },
                  },
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  item: {
                    '@type': 'Person',
                    name: 'Qamar Majeeb',
                    jobTitle: 'Senior Combat & Fitness Trainer',
                    description: 'Hands-on coaching experience in boxing, kickboxing, fitness conditioning, and weight loss transformation.',
                    affiliation: { '@type': 'Organization', name: 'Moin Khan Boxing Academy', '@id': `${siteUrl}/#organization` },
                  },
                },
                {
                  '@type': 'ListItem',
                  position: 3,
                  item: {
                    '@type': 'Person',
                    name: 'Kashif Boxer',
                    jobTitle: 'MMA & Martial Arts Trainer',
                    description: 'Specializes in mixed martial arts and striking disciplines with dynamic combat training experience in MMA, kickboxing, and Wushu Kung Fu.',
                    affiliation: { '@type': 'Organization', name: 'Moin Khan Boxing Academy', '@id': `${siteUrl}/#organization` },
                  },
                },
              ],
            },
          },
        ]}
      />
      {/* SECTION 1 — HERO */}
      <section className="relative pt-24 md:pt-28 pb-12 md:pb-16 overflow-hidden min-h-[520px] md:min-h-[600px] flex items-center">
        <div className="absolute inset-0 z-0">
          <img
            src={HERO_BG}
            alt="Elite trainers"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-boxing-black/70" />
          <div className="absolute inset-0 bg-gradient-to-t from-boxing-black via-transparent to-boxing-black/50" />
          <div className="absolute inset-0 bg-gradient-to-r from-boxing-black/80 via-transparent to-boxing-black/80" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 w-full text-center">
          <SectionWrapper>
            <span className="section-label">/ Our Team</span>
            <h1 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-4">
              <span className="block text-white">MEET OUR</span>
              <span className="block text-boxing-red text-red-glow">ELITE TRAINERS</span>
            </h1>
            <p className="font-poppins text-white/70 text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-8">
              Train under experienced combat sports professionals dedicated to building strength, discipline, technique, and champion mindset.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm md:text-base px-10 py-4"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-check-line text-lg" />
              </span>
              BOOK A FREE TRIAL
            </a>
          </SectionWrapper>
        </div>
      </section>

      {/* SECTION 2 — TRAINERS SHOWCASE */}
      <section className="bg-boxing-black py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <SectionWrapper className="text-center mb-12 md:mb-16">
            <span className="section-label">/ The Team</span>
            <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              Expert <span className="text-highlight">Coaches</span>
            </h2>
            <div className="w-16 h-[2px] bg-boxing-red mx-auto mt-5" />
          </SectionWrapper>

          <div className="flex flex-col gap-16 md:gap-24">
            {trainers.map((trainer, index) => (
              <SectionWrapper key={trainer.name} delay={index * 120}>
                <div
                  className={`flex flex-col ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  } gap-8 lg:gap-14 items-center`}
                >
                  {/* Image */}
                  <div className="w-full lg:w-[42%]">
                    <div className="relative rounded-xl overflow-hidden border border-white/5 group">
                      <img
                        src={trainer.image}
                        alt={trainer.name}
                        className="w-full h-[480px] md:h-[560px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-boxing-black/80 via-transparent to-transparent" />
                      <div className="absolute inset-0 bg-gradient-to-l from-boxing-red/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                      {/* Red accent bar */}
                      <div
                        className={`absolute ${
                          index % 2 === 0 ? 'left-0' : 'right-0'
                        } top-0 bottom-0 w-1 bg-boxing-red`}
                      />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="w-full lg:w-[58%]">
                    <span className="section-label mb-2">
                      / Trainer {String(index + 1).padStart(2, '0')}
                    </span>
                    <h2 className="heading-mixed text-3xl md:text-4xl lg:text-5xl mb-2">
                      {trainer.name}
                    </h2>
                    <p className="font-oswald uppercase tracking-[2px] text-boxing-red text-sm md:text-base mb-6">
                      {trainer.designation}
                    </p>

                    <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6">
                      {trainer.intro}
                    </p>

                    <div className="mb-6">
                      <span className="text-white/50 text-xs uppercase tracking-[2px] font-oswald mb-3 block">
                        Specialties
                      </span>
                      <div className="flex flex-wrap gap-2">
                        {trainer.specialties.map((s) => (
                          <span
                            key={s}
                            className="inline-flex items-center bg-boxing-red/10 border border-boxing-red/30 text-boxing-red text-xs uppercase tracking-wider font-oswald font-bold px-3 py-1.5 rounded-full"
                          >
                            {s}
                          </span>
                        ))}
                      </div>
                    </div>

                    <a
                      href={WHATSAPP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-primary text-xs"
                    >
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-whatsapp-line text-sm" />
                      </span>
                      Train With {trainer.name.split(' ')[0]}
                    </a>
                  </div>
                </div>
              </SectionWrapper>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 3 — WHY TRAIN WITH OUR COACHES */}
      <section className="bg-boxing-darker py-16 md:py-24 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <SectionWrapper className="text-center mb-12 md:mb-16">
            <span className="section-label">/ Our Approach</span>
            <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              WHY TRAIN WITH <span className="text-highlight">OUR COACHES</span>
            </h2>
            <div className="w-16 h-[2px] bg-boxing-red mx-auto mt-5" />
          </SectionWrapper>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {reasons.map((reason, index) => (
              <SectionWrapper key={reason.title} delay={index * 100}>
                <div className="card-glow bg-boxing-black/60 backdrop-blur-sm rounded-xl p-6 md:p-8 h-full border border-white/[0.06]">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-boxing-red/10 rounded-lg mb-4">
                    <i className={`${reason.icon} text-boxing-red text-xl md:text-2xl`} />
                  </span>
                  <h3 className="font-oswald uppercase text-base md:text-lg tracking-wide text-white mb-2">
                    {reason.title}
                  </h3>
                  <p className="text-boxing-textgray text-sm leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </SectionWrapper>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 4 — CTA */}
      <section className="relative py-16 md:py-24 lg:py-28 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20moody%20boxing%20training%20room%20with%20punching%20bags%20and%20boxing%20ring%20in%20background%2C%20dramatic%20cinematic%20red%20lighting%20on%20black%20background%2C%20smoke%20and%20atmosphere%2C%20professional%20sports%20photography%2C%20high%20contrast%2C%20premium%20boxing%20gym%20aesthetic%2C%20intense%20training%20environment&width=1920&height=800&seq=trainers-cta-bg&orientation=landscape"
            alt="Start training"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-boxing-black/80" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12 text-center">
          <SectionWrapper>
            <span className="section-label">/ Take Action</span>
            <h2 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-4">
              START YOUR TRAINING
              <br />
              <span className="text-highlight">JOURNEY TODAY</span>
            </h2>
            <p className="font-poppins text-white/70 text-sm md:text-base max-w-lg mx-auto mt-5 mb-8 leading-relaxed">
              Join Moin Khan Boxing Academy and train with experienced professionals committed to helping you grow stronger, fitter, and more confident.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm md:text-base px-10 py-4"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg" />
              </span>
              CALL / WHATSAPP NOW
            </a>
          </SectionWrapper>
        </div>
      </section>
    </main>
  );
}